import {white} from "material-ui/styles/colors";

const styles = {
    content: {
        paddingTop: 20,
        paddingBottom: 20,
        overflow: 'auto',
        width: '100%',
        display: 'table',
    },
    progress: {
        textAlign: 'center',
        verticalAlign: 'middle',
        display: "table-cell"
    },
    overlay: {
        paddingTop: 20,
        paddingBottom: 20,
        display: 'table',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1000,
        backgroundColor: white,
        opacity: 0.75
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/Loading/Loading.css.js